import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';

// PrimeNG imports
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { FluidModule } from 'primeng/fluid';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { CheckboxModule } from 'primeng/checkbox';
import { TagModule } from 'primeng/tag';
import { FieldsetModule } from 'primeng/fieldset';
import { ProgressBarModule } from 'primeng/progressbar';
import { InputNumberModule } from 'primeng/inputnumber';
import { DividerModule } from 'primeng/divider';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ConfirmationService } from 'primeng/api';

// Application imports
import { ExecutionsViewModel } from '../viewmodels/executions-viewmodels';
import { ToastService } from 'src/app/toast/toast.service';
import { environment } from '../../../../../environments/environment';
import { ExecutionService } from '../services/execution.service';
import { StepsService } from 'src/app/modules/steps/services/steps.service';
import { ExecutionResultService } from 'src/app/services/execution-result.service';
import { TestExecutorService } from 'src/app/services/test-executor.service';
import { StepPlaceholderService } from 'src/app/services/step-placeholder.service';
import { SessionPoolService } from 'src/app/services/session-pool.service';
import { FuntionalAreaService } from 'src/app/modules/test-suite/services/test-suite.service';
import { AuthService } from 'src/app/auth/login/services/auth.service';
import { ReportApiService } from 'src/app/modules/report/services/report-api.service';

@Component({
  selector: 'app-executions',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    TableModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    TextareaModule,
    SelectModule,
    MultiSelectModule,
    ToastModule,
    ConfirmDialogModule,
    TooltipModule,
    FluidModule,
    IconFieldModule,
    InputIconModule,
    CheckboxModule,
    TagModule,
    FieldsetModule,
    ProgressBarModule,
    InputNumberModule,
    DividerModule,
    RadioButtonModule
  ],
  providers: [
    ConfirmationService,
    ExecutionService
  ],
  templateUrl: './executions.component.html',
  styleUrls: ['./executions.component.scss']
})
export class ExecutionsComponent implements OnInit, OnDestroy {
  viewModel: ExecutionsViewModel;
  Math = Math; // Expose Math to template
  // (Removed chart helpers)

  constructor(
    private http: HttpClient,
    private toastService: ToastService,
    private confirmationService: ConfirmationService,
    private executionService: ExecutionService,
    private stepsService: StepsService,
    private executionResultService: ExecutionResultService,
    private testExecutorService: TestExecutorService,
    private stepPlaceholderService: StepPlaceholderService,
    private sessionPoolService: SessionPoolService,
    private functionalAreaService: FuntionalAreaService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private reportApiService: ReportApiService
  ) {
    this.viewModel = new ExecutionsViewModel(
      this.http,
      this.toastService,
      this.confirmationService,
      this.executionService,
      this.stepsService,
      this.executionResultService,
      this.testExecutorService,
      this.stepPlaceholderService,
      this.sessionPoolService,
      this.functionalAreaService,
      this.router,
      this.route,
      this.authService,
      this.reportApiService
    );
  }

  ngOnInit(): void {
    this.viewModel.init();
  }

  ngOnDestroy(): void {
    // Clear any per-row execution statuses on component teardown
    try {
      this.viewModel.clearAllExecutionStatuses();
    } catch {}
    // Stop cloud polling if active
    try {
      this.viewModel.cleanup();
    } catch {}
  }

  // Helper methods for result dialog
  getPassedCount(results: any[]): number {
    return results.filter(r => r.failedCount === 0).length;
  }

  getFailedCount(results: any[]): number {
    return results.filter(r => r.failedCount > 0).length;
  }

  isResultPassed(result: any): boolean {
    return result.failedCount === 0;
  }
}
